import { mapErrorMessage } from '@/shared/utils/map-error-message';

/**
 * Safe message extraction from `unknown` — a thin alias over the single
 * body-aware extractor in `shared/utils/map-error-message.ts`, keeping this
 * module's historical default.
 */
export const getErrorMessage = (error: unknown, defaultMsg?: string) =>
  mapErrorMessage(error, defaultMsg ?? 'Unknown error');

/**
 * Provide a condition and if that condition is falsy, this throws an error with the provided message.
 *
 * @example
 * invariant(typeof value === 'string', 'value must be a string')
 *
 * @param condition The condition to check
 * @param message The message to throw (or a callback to generate the message)
 *
 * @throws {Error} if condition is falsy
 */
export function invariant<TCondition>(
  condition: TCondition,
  message: string | (() => string)
): asserts condition {
  if (!condition) {
    throw new Error(typeof message === 'function' ? message() : message);
  }
}
